import { render, staticRenderFns } from "./DowngradeTariffModal.vue?vue&type=template&id=f20cc440&scoped=true"
import script from "./DowngradeTariffModal.vue?vue&type=script&lang=ts"
export * from "./DowngradeTariffModal.vue?vue&type=script&lang=ts"
import style0 from "./DowngradeTariffModal.vue?vue&type=style&index=0&id=f20cc440&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20cc440",
  null
  
)

export default component.exports